import script from "./ModuleConfigurator.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModuleConfigurator.vue?vue&type=script&lang=ts&setup=true"

import "./ModuleConfigurator.vue?vue&type=style&index=0&id=6b6e3a2b&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b6e3a2b"]])

export default __exports__